/**
 * Produkttyper som delar samma kassalogik som studentflak:
 * inga leveransalternativ för utrustning; adress används som spelplats/referens.
 */
export function isStudentPackageProduct(product: {
  category?: string;
  slug?: string;
}): boolean {
  const category = String(product?.category ?? '').toLowerCase();
  const slug = String(product?.slug ?? '').toLowerCase();
  return category.includes('studentflak') || slug.includes('studentflak');
}

/** Dold DJ-bokningsprodukt (kategori DJ-bokning eller slug dj-booking-*) */
export function isDjBookingProduct(product: {
  category?: string;
  slug?: string;
}): boolean {
  const category = String(product?.category ?? '').toLowerCase();
  const slug = String(product?.slug ?? '').toLowerCase();
  return category.includes('dj-bokning') || slug.startsWith('dj-booking-');
}

export function cartSkipsDeliveryChoiceCheckout(
  items: { product: { category?: string; slug?: string } }[]
): boolean {
  return (
    items.length > 0 &&
    items.every(
      (i) =>
        isStudentPackageProduct(i.product) || isDjBookingProduct(i.product)
    )
  );
}

/** RCF HDL 6-A – minimumhyra 6 enheter (line array). */
export const RCF_HDL_6A_PRODUCT_ID = 'dc91e2d8-15e8-470f-83bc-6d4a7ac37f35';
export const RCF_HDL_6A_SLUG = 'rcf-hdl-6-a-kompakt-line-array';
export const RCF_HDL_6A_MIN_QUANTITY = 6;
/** Övre gräns i kund-UI när min > 1 (skalning ovanför minimum). */
export const RCF_HDL_6A_MAX_QUANTITY = 12;

type ProductQuantityRef = { id?: string; slug?: string };

export function isRcfHdl6aProduct(product: ProductQuantityRef): boolean {
  const slug = String(product?.slug ?? '').toLowerCase();
  return product?.id === RCF_HDL_6A_PRODUCT_ID || slug === RCF_HDL_6A_SLUG;
}

/** Hård minsta hyreskvantitet per produkt (default 1). */
export function getProductMinQuantity(product: ProductQuantityRef): number {
  if (isRcfHdl6aProduct(product)) return RCF_HDL_6A_MIN_QUANTITY;
  return 1;
}

/** Maxval i boknings-UI (befintligt tak 5 för vanliga produkter). */
export function getProductMaxQuantity(product: ProductQuantityRef): number {
  if (isRcfHdl6aProduct(product)) return RCF_HDL_6A_MAX_QUANTITY;
  return 5;
}

export function clampProductQuantity(
  product: ProductQuantityRef,
  quantity: number
): number {
  const min = getProductMinQuantity(product);
  const max = getProductMaxQuantity(product);
  const q = Number.isFinite(quantity) ? Math.floor(Number(quantity)) : min;
  return Math.min(max, Math.max(min, q));
}
